export const initHideRecipesTitle = () => {
  const recipesTitle = document.querySelector(
    '.et_pb_section.recipe-filter .et_pb_row .dp-dfg-items',
  );

  const recipe = document.querySelector('.et_pb_section.recipe');

  const applyFilterBtn = document.querySelector(
    '.dp-dfg-filter-actions .et_pb_button_wrapper .dp-dfg-filter-trigger-button',
  );

  const recipeSuggestions = document.querySelector(
    '.et_pb_section.recipe-suggestions',
  );

  if (recipe && recipesTitle) {
    recipesTitle.classList.add('remove-title');
  }

  if (applyFilterBtn) {
    applyFilterBtn.addEventListener('click', () => {
      if (recipesTitle) {
        recipesTitle.classList.add('add-title');
        recipesTitle.classList.remove('remove-title');
      }

      if (recipeSuggestions) {
        recipeSuggestions.style.display = 'none';
      }
    });
  }
};
